import React from 'react'

type Props = {
  className?: string
  height?: number
}
export const Separator = ({ className = '', height }: Props): JSX.Element => {
  return <div className={className} style={{ height: `${height}px` }}></div>
}
